<tui-avatar
  size="s"
  [src]="item?.photoId | getImageSrc | tuiFallbackSrc: (item?.name || '' | tuiInitials) | async"
  [style.background]="item && !item.photoId && item.name ? (item.name | tuiAutoColor) : ('' | tuiAutoColor)"
  [round]="true"
></tui-avatar>

<div class="item__text-box">
  <div class="item__title item__title_line item__title_line_2">{{ item?.name }}</div>

  <div class="item__description">{{ item?.description }}</div>
</div>
